import { ConvertedTable } from "components/ClpTable/tableProps.interface"
import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"
import moment from "moment"

export const convertTableForExport: ConvertedTable = (rows, columns, t, tableId, footer) => {
    const translationValues = [
        {
            tableName: ClpTableEnum.LearningAdminResults,
            values: {
                status: {
                    "0": t("learning.titles.not_started", "Not started"),
                    "1": t("learning.titles.passed", "Passed"),
                    "2": t("learning.titles.failed", "Failed"),
                    "3": t("learning.titles.expires_in", "Expires in 30 days")
                },
                recertificationPeriodStatus: {
                    "-1": t("global.inactive", "Inactive"),
                    "0": t("learning.titles.still_in_recert", "In progress"),
                    "1": t("learning.titles.done_in_recert", "Done"),
                    "2": t("global.starting_soon", "Starting soon")

                },
                lastDateForPassedExam: {
                    expired: t("learning.titles.expired", "Expired")
                },

            }
        },
        {
            tableName: ClpTableEnum.IssueReportsArchiveHistory,
            values: {
                status: {
                    0: t("learning.titles.not_started", "Not Started"),
                    1: t("global.new", "New"),
                    2: t("global.planned", "Planned"),
                    3: t("global.ongoing", "Ongoing"),
                    4: t("global.fixed", "Fixed"),
                    5: t("global.completed", "Completed")
                },
                priority: {
                    0: t("global.none", "None"),
                    1: t("global.low", "Low"),
                    2: t("global.medium", "Medium"),
                    3: t("global.high", "High"),
                    4: t("vehicleregistry.driving_ban", "Driving ban"),
                },

            }
        },

    ]

    const translateValues = (tableId: string, columnId: string, cellValue: any) => {
        const table = translationValues.find(x => x.tableName === tableId)
        if (!table) return cellValue

        const column = table.values[columnId as keyof typeof table.values]
        if (column && Object.keys(column).length > 0) {
            return column[cellValue as keyof typeof column] ?? cellValue
        }

        return cellValue
    }

    const translateBool = (cellValue: any) => {
        if (cellValue === "true") return t("global.yes", "Yes")
        if (cellValue === "false") return t("global.no", "No")
        return cellValue
    }

    const formatDates = (cellValue: any) => {
        if (cellValue instanceof Date) {
            return moment(cellValue).format('YYYY-MM-DD')
        }
        const validDateFormats = [
          "YYYY-MM-DD",
          "YYYY-MM-DD HH:mm",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "YYYY-MM-DDTHH:mm:ssZ"
        ]
        if (typeof cellValue === 'string' && moment(cellValue, validDateFormats, true).isValid()) {
            return moment(cellValue).format('YYYY-MM-DD')
        }
        return cellValue
    }

    const newColumns = columns
        .filter((col) => col.header !== "" && !col.meta?.hiddenFilter)
        .map((col) => col.header as string)

    const newRows = rows.map((row) =>
        row
            .getVisibleCells()
            .filter((x) =>
                !x.column.columnDef.meta?.hiddenFilter as boolean &&
                x.column.columnDef.header !== ""
            )
            .map((cell) => {
                const translatedValues = translateValues(tableId as string, cell.column.id, cell.getValue())
                const translatedBool = translateBool(translatedValues)
                return formatDates(translatedBool)
            })
    )

    if (footer !== null) {
        let newFooterRow: any[] = []
        for (const key in footer) {
            const k = key as keyof typeof footer
            newFooterRow.push(footer[k].value)
        }
        newRows.push(newFooterRow)
    }

    let data = newRows.slice()
    data.unshift(newColumns)
    return data

}
